import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import ThemeToggle from './ThemeToggle';

const { FiInfo } = FiIcons;
const { FaRobot } = FaIcons;

const Header = ({ onShowHelp }) => {
  return (
    <header className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-700 sticky top-0 z-50 w-full">
      <div className="container mx-auto px-4 py-4 max-w-full overflow-hidden">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <motion.div 
            className="flex items-center space-x-3"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* Logo Robot Blanco sobre fondo Rosa */}
            <motion.div 
              className="w-12 h-12 bg-[#F54CC8] rounded-xl flex items-center justify-center shadow-lg overflow-hidden"
              initial={{ rotate: -10, scale: 0.8 }}
              animate={{ rotate: 0, scale: 1, transition: { type: "spring", stiffness: 260, damping: 20, delay: 0.2 } }}
            >
              <div className="text-white">
                <FaRobot className="w-7 h-7" />
              </div>
            </motion.div>
            
            <div>
              <motion.h1 
                className="text-2xl font-bold italic leading-tight"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.7 }}
              >
                <span style={{ color: "#2B5596" }}>Innova</span>
                <span style={{ color: "#F54CC8" }}>Prompt</span>
              </motion.h1>
              <motion.p 
                className="text-xs text-gray-500 dark:text-gray-400 font-medium tracking-tight"
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.9 }}
              >
                Crea instrucciones precisas
              </motion.p>
            </div>
          </motion.div>
          
          <div className="flex items-center space-x-4">
            <ThemeToggle />
            <motion.button
              onClick={onShowHelp}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Ayuda"
            >
              <SafeIcon icon={FiInfo} className="w-6 h-6 text-gray-600 dark:text-gray-400" />
            </motion.button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;